export default {
  schedule: {
    date_and_time: 'Fecha y hora*',
    number_of_guests: 'Número de comensales*',
    location: 'Ubicación:',
  },
  personal_information: {
    title: 'Título',
    first_name: 'Nombre',
    enter_first_name: 'Introducir nombre',
    last_name: 'Apellido*',
    enter_last_name: 'Introducir apellido',
    email: 'Correo electrónico',
    enter_email: 'Introducir correo electrónico',
    phone: 'Teléfono',
    annotation: 'Anotación',
    enter_annotation: 'Introducir anotación',
  },
  gender: {
    without_title: 'Sin título',
    male: 'Sr.',
    female: 'Sra.',
  },
  buttons: {
    save: 'Guardar',
  },
  error_messages: {
    invalid_email: 'Introduce una dirección de correo electrónico válida, sin espacios ni diéresis antes de la @.',
    invalid_phone_number: 'Número de teléfono no válido. Revise su información e inténtelo de nuevo.',
    failed_reservation: 'Error al enviar su reserva. Revise su información e inténtelo de nuevo.',
    invalid_reservation_day: 'No aceptamos reservas en este día.',
    no_tables_available: 'Lo sentimos, no quedan mesas disponibles.',
    please_enter_guests: 'Por favor, indique el número de comensales.',
    please_select_time: 'Por favor, seleccione una hora.',
    please_select_last_name: 'Por favor, indique el apellido',
  },
  success_messages: {
    reservation_saved: 'Reserva guardada correctamente',
  },
};
